import {
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { Slot } from "@models/slot.model";
import { TranslateService } from "@ngx-translate/core";
import { ContextMenuComponent } from "@app/shared/components/context-menu/context-menu.component";
import { MenuItem } from "primeng/api";

@Component({
    selector: "app-slot",
    templateUrl: "./slot.component.html",
    styleUrls: ["./slot.component.scss"],
})
export class SlotComponent implements OnInit, OnChanges {
    @ViewChild(ContextMenuComponent, {static: true}) contextMenu: ContextMenuComponent;

    @Input() id;
    @Input() slot: Slot;
    @Input() @HostBinding("class.settings") hasSettings = false;
    @Input() @HostBinding("class.selected") selected = false;

    @Output() select = new EventEmitter<any>();
    @Output() settings = new EventEmitter<any>();
    @Output() copy = new EventEmitter<any>();
    @Output() duplicate = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();
    @Output() tooltipActions = new EventEmitter<any>();

    @HostBinding("attr.data-position") position = "bottom";
    @HostBinding("attr.data-delay") delay = 50;
    @HostBinding("attr.data-tooltip") tooltip = "bum";

    @HostBinding("class.has-batches") hasBatches = false;

    contextMenuItems: MenuItem[] = [];

    constructor(private translate: TranslateService) {
        this.contextMenuItems = [
            {
                label: this.translate.instant('generic.buttons.copy'),
                icon: "fa fa-copy",
                command: () => this.onCopy(),
            },
            {
                label: this.translate.instant('generic.buttons.duplicate'),
                icon: "fa fa-clone",
                command: () => this.onDuplicate(),
            },
            {
                label: this.translate.instant('generic.buttons.edit'),
                icon: "fa fa-pencil",
                command: () => this.onEdit(),
            },
            {
                label: this.translate.instant('generic.buttons.delete'),
                icon: "fa fa-trash",
                command: () => this.onDelete(),
            },
        ];
    }

    ngOnInit(): void {
        this.translate.onLangChange.subscribe((event) => {
            this.tooltipActions.emit({action: "tooltip", params: [""]});
        });
    }

    @HostListener("click", ["$event.target"])
    onSlotClick() {
        if (this.hasBatches || this.hasSettings) {
            this.select.emit(this.slot);
        }
    }

    onSettingsClick(event) {
        event.stopPropagation();
        event.preventDefault();
        if (this.hasBatches || this.hasSettings) {
            this.settings.emit(this.slot);
        }
        this.contextMenu.show(event);
    }

    onDelete() {
        this.delete.emit(this.slot);
    }

    onDuplicate() {
        this.duplicate.emit(this.slot);
    }

    onEdit() {
        this.edit.emit(this.slot);
    }

    onCopy() {
        this.copy.emit(this.slot);
    }

    closeContextMenu() {
        this.contextMenu.close();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["slot"]) {
            this.hasBatches = this.slot && this.slot.hasTools;
        }
    }
}
